// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2024 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import AccessTokenSchema from './access-token-schema';

const schema = {
  $id: '/auth-token-schema',
  type: 'object',
  required: [],
  properties: {
    accessToken: {
      ...AccessTokenSchema,
    },
    refreshToken: {
      type: 'string',
      nullable: true,
    },
  },
} as IJSONSchema;

export default schema;
